import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import DatePicker from "react-datepicker"
import { toast } from 'react-toastify'

import FilterSearch from 'pages/parts/FilterSearch'

import { httpOk, GET, POST } from 'helpers/api'
import { formatDate, formatMoney, returnSign, regexPhoneNumber } from 'helpers/helpers'

function Index() {
	const { t } = useTranslation()
	const date = new Date()

	const [data, setData] = useState([])
	const [total, setTotal] = useState(0)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		start_date: new Date(date.getFullYear(), date.getMonth(), date.getDate() - 2),
		end_date: new Date(),
		search: '',
		random: 0,
	})

	useEffect(() => {
		searchWithFilter()
	}, [filterData.random]) // eslint-disable-line react-hooks/exhaustive-deps

	async function searchWithFilter() {
		var urlParams = ""
		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + formatDate(filterData.start_date, 'yyyy-MM-dd')
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + formatDate(filterData.end_date, 'yyyy-MM-dd')
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search

		const response = await GET('/warehouse-cheques' + (urlParams ? '?' + urlParams : ''), {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data.data || [])
			setTotal(response.data.total || 0)
			setFilterDataExist(!!(filterData.start_date || filterData.end_date || filterData.search))
		}
	}

	async function shipOrder(id) {
		const response = await POST(`/board/ship/${id}`, {}, { loader: true })
		if (httpOk(response)) {
			toast.success("Chek chiqarib yuborildi")
			setFilterData(prev => ({ ...prev, random: prev.random + 1 }))
		}
	}

	function resetFilter() {
		setFilterData({
			start_date: new Date(date.getFullYear(), date.getMonth(), date.getDate() - 2),
			end_date: new Date(),
			search: '',
			random: filterData.random + 1,
		})
	}

	return (
		<>
			<div className="page-header d-between mb-2">
				<h4 className="vertical-center">
					Tayyor zakazlar [{total}]
				</h4>
				<div className="ms-auto fw-semibold text-end" style={{ fontSize: '1.1rem' }}>
					Jami: {formatMoney(data.reduce((s, r) => s + Number(r.total_amount || 0), 0))}
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<FilterSearch
								filterData={filterData}
								setFilterData={setFilterData}
							/>
							<DatePicker
								className="form-control"
								selected={filterData.start_date}
								onChange={d => setFilterData(prev => ({ ...prev, start_date: d }))}
								dateFormat="dd.MM.yyyy"
								selectsStart
								startDate={filterData.start_date}
								endDate={filterData.end_date}
								placeholderText={t('start_date')}
							/>
							<DatePicker
								className="form-control"
								selected={filterData.end_date}
								onChange={d => setFilterData(prev => ({ ...prev, end_date: d }))}
								dateFormat="dd.MM.yyyy"
								selectsEnd
								startDate={filterData.start_date}
								endDate={filterData.end_date}
								minDate={filterData.start_date}
								placeholderText={t('end_date')}
							/>
							<button
								className="btn btn-outline-primary"
								onClick={searchWithFilter}
							>
								<i className="uil-search"></i>
							</button>
						</div>
					</div>

					{filterDataExist && (
						<div className="d-flex justify-content-between mb-2">
							<div className="fst-italic text-muted" style={{ fontSize: '0.82rem' }}>
								Filtr: {filterData.start_date && formatDate(filterData.start_date, 'dd.MM.yyyy')}
								{filterData.end_date && ' – ' + formatDate(filterData.end_date, 'dd.MM.yyyy')}
							</div>
							<button className="btn btn-outline-secondary btn-sm" onClick={resetFilter}>
								{t('reset')}
							</button>
						</div>
					)}

					<div className="table-responsive">
						<table className="table table-hover mb-0">
							<thead>
								<tr>
									<th style={{ width: '50px' }}>#</th>
									<th style={{ width: '80px' }}>Chek №</th>
									<th>{t('client')}</th>
									<th style={{ width: '140px' }}>{t('phone')}</th>
									<th style={{ width: '120px' }}>{t('cashier')}</th>
									<th style={{ width: '130px' }}>Tур</th>
									<th style={{ width: '160px' }}>Ochildi</th>
									<th style={{ width: '160px' }}>Vada</th>
									<th className="text-end" style={{ width: '130px' }}>{t('amount')}</th>
									<th style={{ width: '60px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data.length === 0 && (
									<tr>
										<td colSpan={10} className="text-center text-muted py-4">
											Tayyor zakaz yo'q
										</td>
									</tr>
								)}
								{data.map((item, index) => {
									const now = new Date()
									const deadline = item.delivery_date ? new Date(item.delivery_date) : null
									const isOverdue = deadline && deadline < now
									const isToday = deadline && deadline.toDateString() === now.toDateString()

									return (
										<tr key={item.id}>
											<td className="text-center">{item.row_number}</td>
											<td className="fw-bold text-success">#{item.id}</td>
											<td className="td-ellipsis">{item.client_name}</td>
											<td>{regexPhoneNumber(item.client_phone)}</td>
											<td className="td-ellipsis">{item.cashier_name}</td>
											<td>{item.client_type_name}</td>
											<td>{formatDate(item.cheque_opened_at, 'dd.MM.yyyy HH:mm')}</td>
											<td>
												{deadline ? (
													<span
														className={`badge ${isOverdue ? 'bg-danger' : isToday ? 'bg-warning text-dark' : 'bg-success'}`}
														style={{ fontSize: '0.8rem' }}
													>
														{formatDate(item.delivery_date, 'dd.MM.yyyy HH:mm')}
													</span>
												) : (
													<span className="text-muted">—</span>
												)}
											</td>
											<td className="text-end fw-semibold">{formatMoney(item.total_amount)}</td>
											<td className="py-0 text-center" style={{ verticalAlign: 'middle' }}>
												<button
													className="btn btn-success btn-sm"
													title="Chiqarib yuborish"
													onClick={() => shipOrder(item.id)}
												>
													<i className="uil-arrow-circle-right"></i>
												</button>
											</td>
										</tr>
									)
								})}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index
